/** Mirror mode: second cursor reflected across screen center (player controls primary only). */

export const MIRROR_CURSOR_STROKE = "#ff66cc";
export const MIRROR_CURSOR_FILL = "rgba(255, 102, 204, 0.5)";

export function mirrorCursorPos(
  x: number,
  y: number,
  canvasW: number,
  canvasH: number,
): { x: number; y: number } {
  return { x: canvasW - x, y: canvasH - y };
}

export function drawMirrorCursorOnto(
  c: CanvasRenderingContext2D,
  x: number,
  y: number,
  radius: number,
): void {
  c.save();
  c.globalCompositeOperation = "source-over";
  c.fillStyle = MIRROR_CURSOR_FILL;
  c.strokeStyle = MIRROR_CURSOR_STROKE;
  c.lineWidth = Math.max(1.5, radius * 0.38);
  c.setLineDash([Math.max(2, radius * 0.55), Math.max(2, radius * 0.4)]);
  c.beginPath();
  c.arc(x, y, radius, 0, Math.PI * 2);
  c.fill();
  c.stroke();
  c.setLineDash([]);
  c.globalAlpha = 0.9;
  c.lineWidth = Math.max(1, radius * 0.18);
  c.beginPath();
  c.arc(x, y, radius * 0.42, 0, Math.PI * 2);
  c.stroke();
  c.restore();
}
